export default __webpack_public_path__ + "static/media/chess.196901a4.png";